import { InputComponentMetadata } from "@eavfw/quickform-core";
import { TextProperties } from "./TextInput";

export const textInputSchema: InputComponentMetadata<TextProperties> = {
    label: "Text",
    uiSchema: {
        paragraph: {
            "ui:widget": "textarea"
        },
        unit: {
            "ui:field": "UnitLookupField",
        },
    },
    schema: {
        type: "object",

        properties: {
            text: {
                title: "Text",
                type: "string"
            },
            placeholder: {
                title: "Placeholder",
                type: "string"
            },
            paragraph: {
                title: "Paragraph",
                type: "string"
            },
            unit: {
                title: "Unit",
                type: "string"
            },
            beforeIcon: {
                enum: [
                    "Phone",
                    "Email",
                    "User"
                ],
                // @ts-ignore
                "enumNames": [
                    "Phone",
                    "Email",
                    "User"
                ]
            },
            afterIcon: {
                enum: [
                    "Phone",
                    "Email",
                    "User"
                ],
                // @ts-ignore
                "enumNames": [
                    "Phone",
                    "Email",
                    "User"
                ]
            }
        }
    }, field: {
        type: "text",
    }
}